/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementListShowForSelectResponse } from './ShowManagementListShowForSelectResponse';

export type ShowManagementListShowForSelectResponseApiRespoonse = {
    data?: ShowManagementListShowForSelectResponse;
    status?: ShowManagementListShowForSelectResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementListShowForSelectResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

